"use client";

import React from "react";
import { ArrowRight, Eye, Sparkles } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: 1,
  title: "Executive Sedan",
  category: "Luxury Comfort",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/fintech_dashboard_preview.png",
  link: "/FleetPage"
}, {
  id: 2,
  title: "Premium SUV",
  category: "Spacious Elegance",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/healthcare_portal_preview.png",
  link: "/FleetPage"
}, {
  id: 3,
  title: "Luxury Sprinter",
  category: "Group Travel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ecommerce_admin_preview.png",
  link: "/FleetPage"
}, {
  id: 4,
  title: "Stretch Limousine",
  category: "Special Occasions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/saas_metrics_preview.png",
  link: "/FleetPage"
}, {
  id: 5,
  title: "Private Chauffeur",
  category: "Professional Travel",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/crypto_exchange_preview.png",
  link: "/ServicesPage"
}, {
  id: 6,
  title: "Airport Transfer",
  category: "Reliable Transit",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/social_manager_preview.png",
  link: "/ServicesPage"
}];
export default function DesignGallery() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="121480" id="luxury-fleet-showcase" className="relative w-full bg-background py-24 overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/5 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        {}
        <div ref={headerRef} className={`max-w-2xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/10 text-secondary text-sm font-medium mb-6">
            <Sparkles className="size-4" />
            <span>Our Exclusive Fleet</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground tracking-tight mb-4">
            Luxury Fleet Showcase
          </h2>
          <p className="text-lg text-muted-foreground">
            Experience the pinnacle of comfort and style with our meticulously maintained collection of premium vehicles.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {galleryItems.map((item, index) => <Card key={item.id} data-index={index} className="group relative overflow-hidden rounded-2xl border-[0.5px] border-white/20 bg-white/60 backdrop-blur-md shadow-soft transition-all duration-500 hover:scale-[1.02] hover:border-secondary hover:shadow-medium cursor-pointer flex flex-col">
              <div className="relative overflow-hidden">
                <AspectRatio ratio={16 / 9}>
                  <img src={item.image} alt={item.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                  {}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/40 via-primary-dark/5 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-90" />
                </AspectRatio>

                {}
                <div className="absolute inset-0 z-10 flex items-center justify-center opacity-0 transition-all duration-500 group-hover:opacity-100 bg-primary-dark/20 backdrop-blur-[2px]">
                  <Button variant="default" size="lg" className="translate-y-8 transition-all duration-500 cubic-bezier(0.4, 0, 0.2, 1) group-hover:translate-y-0 shadow-xl bg-secondary hover:bg-secondary-hover text-foreground-secondary" asChild>
                    <Link to={item.link}>
                      <Eye className="mr-2 size-4" />
                      View Details
                    </Link>
                  </Button>
                </div>
              </div>

              <CardContent className="p-6 relative z-20 bg-white/10 backdrop-blur-sm border-t border-white/10 flex-grow flex flex-col justify-center group-hover:border-b-4 group-hover:border-b-secondary transition-all duration-300">
                <h3 className="font-display text-xl font-bold text-foreground mb-1.5 tracking-tight transition-colors duration-300 group-hover:text-secondary">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground font-medium">
                  {item.category}
                </p>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="mt-16 text-center">
          <Button variant="outline" size="lg" className="rounded-md px-8 border-secondary text-secondary hover:bg-secondary hover:text-white transition-all duration-300" asChild>
            <Link to="/FleetPage">
              Explore Our Fleet
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}